import {SchemeLink} from '../../../applink/SchemeLink';
import {
  HistoryLineBanner,
  HistoryLineBannerType,
  Maybe,
} from '../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {getInternalAssetImage} from '../../atoms/StaticImage/getInternalAssetImage.function';
import {InternalStaticImageType} from '../../atoms/StaticImage/InternalStaticImageType.enum';
import {STATIC_IMAGE_INFO_MAP} from '../../atoms/StaticImage/StaticImageInfoMap.constant';
import {LineBanner} from '../LineBanner/LineBanner';

interface Props {
  banner: Maybe<HistoryLineBanner>;
}

export function CashHistoryLineBanner({banner}: Props) {
  if (!banner) {
    return null;
  }

  const {scheme, title, subTitle, bgColor, bannerType} = banner;

  const rightImageType = RIGHT_IMAGE_TYPE_MAP[bannerType];

  return (
    <div className="mx-11pxr mt-11pxr mb-4pxr">
      <SchemeLink scheme={scheme}>
        <LineBanner
          {...putTiaraObjectProps({
            click: {
              layer1: '캐시내역배너',
              copy: EVENT_LOG_CLICK_COPY_MAP[bannerType],
            },
          })}
          bannerTitle={title}
          subTitle={subTitle}
          bgColor={bgColor}
          rightImage={getInternalAssetImage(
            STATIC_IMAGE_INFO_MAP[rightImageType].srcStatic || ''
          )}
          onClick={e => LOG_CLICK_EVENT('캐시배너_클릭', e)}
        />
      </SchemeLink>
    </div>
  );
}

const RIGHT_IMAGE_TYPE_MAP: Record<
  HistoryLineBannerType,
  InternalStaticImageType
> = {
  HELIX: InternalStaticImageType.CashBannerHelixStatic,
  RECENT: InternalStaticImageType.CashBannerRecentStatic,
  MILLION: InternalStaticImageType.CashBannerMillionStatic,
};

const EVENT_LOG_CLICK_COPY_MAP: Record<HistoryLineBannerType, string> = {
  HELIX: '헬릭스랜딩',
  RECENT: '최근본',
  MILLION: '밀리언',
};
